module.exports = __webpack_public_path__ + "img/avatar.24f7150e.png";